import { render, staticRenderFns } from "./Karin-report.vue?vue&type=template&id=e27f5b4c"
import script from "./Karin-report.vue?vue&type=script&lang=js"
export * from "./Karin-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports